function TileGrid({ tiles }) {
  return (
    <section className="tile-grid" aria-label="Skill tiles">
      {tiles.map((tile, index) => (
        <article
          className={`tile ${tile.items.length > 5 ? 'tile--compact' : ''}`}
          key={tile.id}
          style={{
            '--accent': tile.accent,
            '--delay': `${index * 120}ms`,
          }}
        >
          <div className="tile-head">
            <h2>{tile.title}</h2>
            <span className="tile-count">{tile.items.length} tools</span>
          </div>
          <ul className={`tile-list ${tile.items.length > 5 ? 'tile-list--split' : ''}`}>
            {tile.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <div className="tile-glow" aria-hidden="true" />
        </article>
      ))}
    </section>
  )
}

export default TileGrid
